export const PHASE_GROUP_TYPE_GET_ALL_REQUEST =
  'PHASE_GROUP_TYPE_GET_ALL_REQUEST';
export const PHASE_GROUP_TYPE_GET_ALL_REQUEST_SUCCESS =
  'PHASE_GROUP_TYPE__GET_ALL_REQUEST_SUCCESS';

export const getPhaseGroupTypes = data => ({
  type: PHASE_GROUP_TYPE_GET_ALL_REQUEST,
  payload: data,
});
